import cn from 'classnames';

import { CheckIcon } from '../Icons';

import style from './Checkbox.module.scss';

export default function Checkbox({ id, error, children, ...rest }) {
  return (
    <div className={cn(style.checkbox, error && style.bad)}>
      <input
        type='checkbox'
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        {...rest}
      />
      <label htmlFor={id}>
        <span className={style.box}>
          <CheckIcon />
        </span>
        <span>{children}</span>
      </label>
      {error && (
        <p
          className={style.err}
          id={`${id}-error`}
        >
          {error}
        </p>
      )}
    </div>
  );
}
